// AGC: Admin page header — title, subtitle, and right-aligned actions slot
import React from 'react'

interface AdminPageHeaderProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
  className?: string
}

export const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({
  title,
  subtitle,
  actions,
  className = '',
}) => (
  <div className={`flex items-start justify-between flex-wrap gap-3 mb-6 ${className}`}>
    <div>
      <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 tracking-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{subtitle}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
)
